import React from 'react';
import Header from '../components/Header.js';
import Footer from '../components/Footer.js';
import EthicsPageContent from '../components/EthicsPageContent.js';


const EthicsPage = () => (
    <div>
        <Header />
        <EthicsPageContent />
        <Footer />
    </div>
);


export default EthicsPage;